import HeroComp from "./hero";
import MyCollection from "./myCollection";

import NftStaking from "./nftStaking";
import FaqComp from "./faq";
import ShadowComp from "components/shadow";
import Faqshadow from "components/shadow/faqshadow";

const HomeCom = () => {
  return (
    <div style={{ overflowX: "clip" }}>
      <HeroComp />
      <div
        style={{
          position: "relative",
          isolation: "isolate",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: "35%",
            right: "0",
            zIndex: -1,
          }}
          className="my-collection"
        >
          <ShadowComp />
        </div>
        <MyCollection />
      </div>
      <div
        style={{
          position: "relative",
          isolation: "isolate",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: "40%",
            right: "0",
            zIndex: -1,
          }}
        >
          <ShadowComp />
        </div>
        <div
          style={{
            position: "absolute",
            top: "0%",
            left: "0",
            zIndex: -1,
          }}
        >
          <ShadowComp />
        </div>
        <NftStaking />
      </div>

      <div
        style={{
          position: "relative",
          isolation: "isolate",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: "40%",
            right: "0",
            zIndex: -1,
          }}
        >
          <Faqshadow />
        </div>
        <div
          style={{
            position: "absolute",
            top: "20%",
            left: "0",
            zIndex: -1,
          }}
        >
          <Faqshadow />
        </div>
        <FaqComp />
      </div>
    </div>
  );
};

export default HomeCom;
